/**
 * Returns true if the Web Serial API is supported by the current browser
 *
 * Note this cannot just be a constant as window.qest is updated at runtime
 */
export const isWebSerialApiSupported = () =>
  'serial' in navigator &&
  // For the web browser embedded in QESTLab, the prompt to select a port does not appear (even when serial is well-defined in navigator)
  // For now we exclude this from supported browsers explicitly
  !window.qest?.isFrame;
